namespace Gamification.Gamification {
    export interface ProdottiAssetEsperienzeRow {
        IdProdottoAssetEsperienza?: number;
        UserId?: number;
        TenantId?: number;
        IdProdotto?: number;
        IdAssetEsperienza?: number;
        IdProdottoUserId?: number;
        IdProdottoTenantId?: number;
        IdProdottoIdTipologiaProdotti?: number;
        IdProdottoIdentifierProdotto?: string;
        IdProdottoNome?: string;
        IdProdottoDescrizione?: string;
        IdProdottoBozza?: number;
        IdProdottoIdentifierPunteggio?: string;
        IdProdottoPunteggioNome?: string;
        IdProdottoPunteggioValoreIniziale?: number;
        IdProdottoPunteggioNegativo?: number;
        IdProdottoIdentifierCrediti?: string;
        IdProdottoCreditiNome?: string;
        IdProdottoCreditiValoreIniziale?: number;
        IdProdottoIdentifierEsperienza?: string;
        IdProdottoEsperienzaNome?: string;
        IdProdottoEsperienzaValoreIniziale?: number;
        IdAssetEsperienzaUserId?: number;
        IdAssetEsperienzaTenantId?: number;
        IdAssetEsperienzaIdDispositivo?: number;
        IdAssetEsperienzaIdTipologiaEsperienza?: number;
        IdAssetEsperienzaIdentifierAssetEsperienza?: string;
        IdAssetEsperienzaNome?: string;
        IdAssetEsperienzaNomeFileAssetBundle?: string;
        IdAssetEsperienzaNomeFileAssetPathFile?: string;
        IdAssetEsperienzaUrlAssetBundle?: string;
        IdAssetEsperienzaVersioneAssetBundle?: number;
        IdAssetEsperienzaNomeFileCoverAssetBundle?: string;
        IdAssetEsperienzaPathFileCoverAssetBundle?: string;
        IdAssetEsperienzaUrlCoverAssetBundle?: string;
    }

    export namespace ProdottiAssetEsperienzeRow {
        export const idProperty = 'IdProdottoAssetEsperienza';
        export const localTextPrefix = 'Gamification.ProdottiAssetEsperienze';
        export const deletePermission = 'Gamification:Configurazione';
        export const insertPermission = 'Gamification:Configurazione';
        export const readPermission = 'Gamification:Configurazione';
        export const updatePermission = 'Gamification:Configurazione';

        export declare const enum Fields {
            IdProdottoAssetEsperienza = "IdProdottoAssetEsperienza",
            UserId = "UserId",
            TenantId = "TenantId",
            IdProdotto = "IdProdotto",
            IdAssetEsperienza = "IdAssetEsperienza",
            IdProdottoUserId = "IdProdottoUserId",
            IdProdottoTenantId = "IdProdottoTenantId",
            IdProdottoIdTipologiaProdotti = "IdProdottoIdTipologiaProdotti",
            IdProdottoIdentifierProdotto = "IdProdottoIdentifierProdotto",
            IdProdottoNome = "IdProdottoNome",
            IdProdottoDescrizione = "IdProdottoDescrizione",
            IdProdottoBozza = "IdProdottoBozza",
            IdProdottoIdentifierPunteggio = "IdProdottoIdentifierPunteggio",
            IdProdottoPunteggioNome = "IdProdottoPunteggioNome",
            IdProdottoPunteggioValoreIniziale = "IdProdottoPunteggioValoreIniziale",
            IdProdottoPunteggioNegativo = "IdProdottoPunteggioNegativo",
            IdProdottoIdentifierCrediti = "IdProdottoIdentifierCrediti",
            IdProdottoCreditiNome = "IdProdottoCreditiNome",
            IdProdottoCreditiValoreIniziale = "IdProdottoCreditiValoreIniziale",
            IdProdottoIdentifierEsperienza = "IdProdottoIdentifierEsperienza",
            IdProdottoEsperienzaNome = "IdProdottoEsperienzaNome",
            IdProdottoEsperienzaValoreIniziale = "IdProdottoEsperienzaValoreIniziale",
            IdAssetEsperienzaUserId = "IdAssetEsperienzaUserId",
            IdAssetEsperienzaTenantId = "IdAssetEsperienzaTenantId",
            IdAssetEsperienzaIdDispositivo = "IdAssetEsperienzaIdDispositivo",
            IdAssetEsperienzaIdTipologiaEsperienza = "IdAssetEsperienzaIdTipologiaEsperienza",
            IdAssetEsperienzaIdentifierAssetEsperienza = "IdAssetEsperienzaIdentifierAssetEsperienza",
            IdAssetEsperienzaNome = "IdAssetEsperienzaNome",
            IdAssetEsperienzaNomeFileAssetBundle = "IdAssetEsperienzaNomeFileAssetBundle",
            IdAssetEsperienzaNomeFileAssetPathFile = "IdAssetEsperienzaNomeFileAssetPathFile",
            IdAssetEsperienzaUrlAssetBundle = "IdAssetEsperienzaUrlAssetBundle",
            IdAssetEsperienzaVersioneAssetBundle = "IdAssetEsperienzaVersioneAssetBundle",
            IdAssetEsperienzaNomeFileCoverAssetBundle = "IdAssetEsperienzaNomeFileCoverAssetBundle",
            IdAssetEsperienzaPathFileCoverAssetBundle = "IdAssetEsperienzaPathFileCoverAssetBundle",
            IdAssetEsperienzaUrlCoverAssetBundle = "IdAssetEsperienzaUrlCoverAssetBundle"
        }
    }
}
